// extracted by mini-css-extract-plugin
export default {"quoteText":"Quote_quoteText__D60FU","quoteAuthor":"Quote_quoteAuthor__aQC0m","buttonsWrapper":"Quote_buttonsWrapper__05O04","socialLinksWrapper":"Quote_socialLinksWrapper__j44JZ"};